import { createBrowserRouter } from 'react-router'
import { IRoute } from 'types'
import { EventPage, InfoPage, ResultsPage, RootPage } from '../pages'

export enum RoutePath {
  Home = '/',
  Event = `/:id`,
  Results = `${Event}/:id`,
}

export const routes: IRoute[] = [
  {
    path: RoutePath.Home,
    element: <InfoPage />,
  },
  {
    path: RoutePath.Event,
    element: <RootPage />,
    children: [
      { path: RoutePath.Event, element: <EventPage /> },
      { path: RoutePath.Results, element: <ResultsPage /> },
      {
        path: '*',
        element: <InfoPage />,
      },
    ],
  },
]

export default createBrowserRouter(routes)
